import React, { FC, useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import shortid from "shortid";
import { Form, Col, Row, Input, DatePicker, Typography, Select } from "antd";
import "./CghsProcedureClaim.css";
import dayjs from "dayjs";
import { RootState } from "../../../../store/store";

interface SelectOption {
  value: string;
  label: string;
}

type ProceduresCodingProps = {
  cghsProcedures: any;
};

const CghsProcedureClaim: FC<ProceduresCodingProps> = ({ cghsProcedures }) => {
  const { preAuthClaim, patients } = useSelector((state: RootState) => state);
  const [isSubmit, setIsSubmit] = useState<boolean>(false);

  const formattedProceduresOptions = preAuthClaim?.procedureDropDown?.map(
    (option: any) => ({
      value: option?.procedureCode,
      label: option?.procedureName,
    }),
  );

  const formattedProcedureReferral = [
    { label: "REFERRAL", value: "referral" },
    { label: "NON REFERRAL", value: "non referral" },
  ];

  const formattedTreatingDoctorsOptions = [
    {
      treatingDoctorCode: "OTHERS",
      treatingDoctorName: "OTHERS",
    },
  ].map((option) => ({
    label: option.treatingDoctorName, // Using treatingDoctorName as label
    value: option.treatingDoctorCode, // Using treatingDoctorCode as value
  }));

  const formattedAccreditationOptions: { label: string; value: string }[] = [
    { label: "NABH", value: "NABH" },
    { label: "NABL", value: "NABL" },
    { label: "NON NABL", value: "NON NABL" },
    { label: "NON NABH", value: "NON NABH" },
  ];

  const { Text } = Typography;
  const [totalAmount, setTotalAmount] = useState(0);

  useEffect(() => {
    if (cghsProcedures?.length > 0) {
      const total = cghsProcedures?.reduce((sum: any, procedure: any) => {
        const amount = procedure?.specialityType
          ?.toLowerCase()
          ?.includes("s")
          ? parseFloat(procedure?.unspecifiedProcedureAmount || "0") *
            parseFloat(procedure?.numberOfDays)
          : parseFloat(procedure?.procedureAmount || "0") *
            parseFloat(procedure?.numberOfDays);

        return sum + (isNaN(amount) ? 0 : amount);
      }, 0);

      setTotalAmount(total);
    }
  }, [cghsProcedures]);
  const [form] = Form.useForm();

  return (
    <>
      <div
        style={{
          textDecoration: "underline",
          fontSize: "16px",
          margin: "16px 0",
          fontWeight: "bold",
        }}
      >
        Procedure Details
      </div>
      <div>
        <Form
          form={form}
          layout="vertical"
          onFinish={(values) => {
            setIsSubmit(true);
          }}
        >
          <div>
            <div className="procedure-component">
              {cghsProcedures?.map((entry: any, index: number) => (
                <div
                  key={shortid.generate()}
                  className={`entry-box ${index > 0 ? "has-border-top" : ""}`}
                >
                  <div className="index_no">{index + 1}</div>
                  <Row gutter={[16, 16]} className="mt-3">
                    {patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
                    "CGHS" ? (
                      <Col span={4}>
                        <Form.Item
                          label="PROCEDURE REFERRAL"
                          layout="vertical"
                          required
                        >
                          <Select
                            placeholder="SELECT"
                            className={`basic-single ${
                              (cghsProcedures[index]?.procedureReferral ===
                                "" ||
                                !cghsProcedures[index]?.procedureReferral) &&
                              isSubmit
                                ? "border-error"
                                : ""
                            }`}
                            options={formattedProcedureReferral}
                            value={cghsProcedures[index]?.procedureReferral}
                          />
                        </Form.Item>
                      </Col>
                    ) : (
                      <></>
                    )}
                    <Col span={4}>
                      <Form.Item label="PROCEDURE" layout="vertical" required>
                        <Select
                          className={`basic-single ${
                            (cghsProcedures[index]?.procedureCode === "" ||
                              !cghsProcedures[index]?.procedureCode) &&
                            isSubmit
                              ? "border-error"
                              : ""
                          }`}
                          options={formattedProceduresOptions}
                          value={
                            formattedProceduresOptions &&
                            formattedProceduresOptions.find(
                              (option) =>
                                option.label ===
                                cghsProcedures[index]?.procedureName,
                            )
                          }
                          placeholder="SELECT"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Form.Item label="PROCEDURE CODE" layout="vertical">
                        <Input
                          disabled
                          value={
                            cghsProcedures[index]?.externalProcedureCode || ""
                          }
                          placeholder="Procedure Code"
                        />
                      </Form.Item>
                    </Col>

                    <Col span={4}>
                      <Form.Item label="QUANTITY/NO OF DAYS" layout="vertical">
                        <Input
                          value={cghsProcedures[index]?.numberOfDays || ""}
                          name="numberOfDays"
                          placeholder="No Of Days"
                        />
                      </Form.Item>
                    </Col>
                    {patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0]?.toUpperCase() ===
                    "CGHS AB" ? (
                      <></>
                    ) : (
                      <Col span={4}>
                        <Form.Item
                          layout="vertical"
                          label={
                            <>
                              ACCREDITATION STATUS
                              {cghsRequiredField?.includes(
                                "accreditationStatus",
                              ) && <Text type="danger"> *</Text>}
                            </>
                          }
                        >
                          <Select
                            className={`basic-single ${
                              (cghsProcedures[index]?.accreditationStatus ===
                                "" ||
                                !cghsProcedures[index]?.accreditationStatus) &&
                              isSubmit
                                ? "border-error"
                                : ""
                            }`}
                            options={formattedAccreditationOptions}
                            value={formattedAccreditationOptions.find(
                              (option) =>
                                option.label ===
                                cghsProcedures[index]?.accreditationStatus,
                            )}
                          />
                        </Form.Item>
                      </Col>
                    )}
                    {patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0]?.toUpperCase() ===
                    "CGHS AB" ? (
                      <></>
                    ) : (
                      <Col span={4}>
                        <Form.Item
                          layout="vertical"
                          label={
                            <>
                              TREATING DOCTOR
                              {cghsRequiredField?.includes(
                                "treatingDoctor",
                              ) && <Text type="danger"> *</Text>}
                            </>
                          }
                        >
                          <Select
                            className={`basic-single ${
                              (cghsProcedures[index]?.treatingDoctorName ===
                                "" ||
                                !cghsProcedures[index]?.treatingDoctorName) &&
                              isSubmit
                                ? "border-error"
                                : ""
                            }`}
                            options={formattedTreatingDoctorsOptions}
                            value={formattedTreatingDoctorsOptions.find(
                              (option) =>
                                option?.label ===
                                cghsProcedures[index]?.treatingDoctor,
                            )}
                          />
                        </Form.Item>
                      </Col>
                    )}

                    <Col span={4}>
                      <Form.Item label="TREATMENT START DATE" layout="vertical">
                        <DatePicker
                          showTime
                          format="DD-MM-YYYY HH:mm:ss"
                          // min={new Date().toISOString().slice(0, 10)}
                          placeholder="Date"
                          value={dayjs(
                            cghsProcedures[index]?.treatmentStartDate,
                            "DD-MM-YYYY HH:mm:ss",
                          )}
                          name="treatmentStartDate"
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Col>
                    {!cghsProcedures[index]?.specialityType
                      ?.toLowerCase()
                      ?.includes("s") && (
                      <Col span={4}>
                        <Form.Item label="PROCEDURE AMOUNT" layout="vertical">
                          <Input
                            value={cghsProcedures[index]?.procedureAmount || ""}
                            name="procedureAmount"
                            placeholder="PROCEDURE AMOUNT"
                          />
                        </Form.Item>
                      </Col>
                    )}

                    {/* Additional input fields */}
                  </Row>

                  {cghsProcedures[index]?.specialityType
                    ?.toLowerCase()
                    ?.includes("s") && (
                    <Row gutter={16}>
                      <Col span={4}>
                        <Form.Item label="PROCEDURE NAME" layout="vertical">
                          <Input
                            defaultValue={
                              cghsProcedures[index]?.unspecifiedProcedureName ||
                              ""
                            }
                            name="unspecifiedProcedureName"
                            placeholder="PROCEDURE NAME"
                          />
                        </Form.Item>
                      </Col>
                      <Col span={4}>
                        <Form.Item label="AMOUNT" layout="vertical">
                          <Input
                            type="number"
                            name="unspecifiedProcedureAmount"
                            defaultValue={
                              cghsProcedures[index]
                                ?.unspecifiedProcedureAmount || ""
                            }
                            placeholder="AMOUNT"
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  )}

                  {cghsProcedures[index]?.strats
                    ?.toLowerCase()
                    ?.includes("y") && (
                    <Row gutter={16}>
                      <Col span={4}>
                        <Form.Item label="STRATS NAME" layout="vertical">
                          <Input
                            defaultValue={
                              cghsProcedures[index]?.stratsName || ""
                            }
                            name="stratsName"
                            placeholder="STRATS NAME"
                          />
                        </Form.Item>
                      </Col>
                      <Col span={4}>
                        <Form.Item
                          layout="vertical"
                          label={
                            <>
                              STRATS OPTIONS
                              {cghsRequiredField?.includes(
                                "stratOptionValue",
                              ) && <Text type="danger"> *</Text>}
                            </>
                          }
                        >
                          <Input
                            defaultValue={
                              cghsProcedures[index]?.stratOptionValue || ""
                            }
                            name="stratOptionValue"
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  )}
                </div>
              ))}
            </div>
          </div>
          <div style={{ textAlign: "right" }}>
            <h4>TOTAL PREAUTH AMOUNT: ₹ {totalAmount}/-</h4>
            <div></div>
          </div>
        </Form>
      </div>
    </>
  );
};

export const cghsRequiredField = [
  "beneficiaryId",
  "patientOpdIpdNumber",
  "isMedicoLegalCase",
  "procedureConsent",
];

export default CghsProcedureClaim;
